// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.shimmer[data-v-8702774e] {
  background: #f6f7f8;
  background-image: linear-gradient(to right,
      #f6f7f8 0%,
      #edeef1 20%,
      #f6f7f8 40%,
      #f6f7f8 100%);
  background-repeat: no-repeat;
  background-size: 800px 104px;
  display: inline-block;
  position: relative;
  animation: shimmer-8702774e 1.2s infinite linear;
}
@keyframes shimmer-8702774e {
0% {
    background-position: -800px 0;
}
100% {
    background-position: 800px 0;
}
}
.circle[data-v-8702774e] {
  border-radius: 50% !important;
}
`, "",{"version":3,"sources":["webpack://./src/Components/ChatWidget/AssistantAi/AiComponents/SimmerEffect.vue"],"names":[],"mappings":";AA8BA;EACE,mBAAmB;EACnB;;;;mBAIiB;EACjB,4BAA4B;EAC5B,4BAA4B;EAC5B,qBAAqB;EACrB,kBAAkB;EAClB,gDAAuC;AACzC;AAEA;AACE;IACE,6BAA6B;AAC/B;AAEA;IACE,4BAA4B;AAC9B;AACF;AAEA;EACE,6BAA6B;AAC/B","sourcesContent":["<template>\r\n  <div class=\"shimmer\" :class=\"{ circle }\" :style=\"{\r\n    width,\r\n    height,\r\n    borderRadius: circle ? '50%' : '4px'\r\n  }\"></div>\r\n\r\n</template>\r\n\r\n<script>\r\nexport default {\r\n  name: 'Shimmer',\r\n  props: {\r\n    width: {\r\n      type: String,\r\n      default: '100%'\r\n    },\r\n    height: {\r\n      type: String,\r\n      default: '20px'\r\n    },\r\n    circle: {\r\n      type: Boolean,\r\n      default: false\r\n    }\r\n  }\r\n}\r\n</script>\r\n\r\n<style scoped>\r\n.shimmer {\r\n  background: #f6f7f8;\r\n  background-image: linear-gradient(to right,\r\n      #f6f7f8 0%,\r\n      #edeef1 20%,\r\n      #f6f7f8 40%,\r\n      #f6f7f8 100%);\r\n  background-repeat: no-repeat;\r\n  background-size: 800px 104px;\r\n  display: inline-block;\r\n  position: relative;\r\n  animation: shimmer 1.2s infinite linear;\r\n}\r\n\r\n@keyframes shimmer {\r\n  0% {\r\n    background-position: -800px 0;\r\n  }\r\n\r\n  100% {\r\n    background-position: 800px 0;\r\n  }\r\n}\r\n\r\n.circle {\r\n  border-radius: 50% !important;\r\n}\r\n</style>\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
